import { render, staticRenderFns } from "./PremiumAddon.vue?vue&type=template&id=0e250202&scoped=true&"
import script from "./PremiumAddon.vue?vue&type=script&lang=js&"
export * from "./PremiumAddon.vue?vue&type=script&lang=js&"
import style0 from "./PremiumAddon.vue?vue&type=style&index=0&id=0e250202&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e250202",
  null
  
)

export default component.exports